export default __webpack_public_path__ + "static/experienceImg6-647865503e858add6fb4a18cef5a2230.webp";